import { useState, useEffect } from 'react'
import { isSmallScreen as checkSmallScreen } from '../../../../Utils/Misc'

const useSmallScreen = () => {
  const [smallScreen, setSmallScreen] = useState(checkSmallScreen())

  useEffect(() => {
    const handleResize = () => {
      setSmallScreen(checkSmallScreen())
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  return smallScreen
}

export default useSmallScreen
